/* eslint-disable camelcase */
import React from 'react';
import {
  Link,
} from 'react-router-dom';
import {
  Formik,
  Field,
} from 'formik';
import * as Yup from 'yup';

import {
  Flex,
  Text,
  icons,
  Container,
} from 'web-styled';
import {
  Button,
  TextField,
  CheckboxField,
  PasswordField,
  SetNamespace,
} from 'web-components';

import * as S from '../styled';

const validationSchema = Yup.object().shape({
  first_name: Yup.string()
    .required('First name is required'),
  last_name: Yup.string()
    .required('Last name is required'),
  email: Yup.string()
    .email('Email must be a valid email')
    .required('Email is required'),
  password: Yup.string()
    .min(6)
    .required('Password is required'),
  password_confirmation: Yup.string()
    .required('Confirm password is required')
    .oneOf([Yup.ref('password'), null], 'Passwords do not match'),
  agreement: Yup.bool()
    .oneOf([true], 'Must Accept Terms and Conditions')
    .required('is required'),
});

interface Props {
  params: {
    first_name: string;
    last_name: string;
    email: string;
  }
  onSubmit: { (data: any, actions: any): void },
}

const ProForm = ({
  params,
  onSubmit,
}: Props) => (
  <Container
    spacing={30}
    margin="5% auto 0 auto"
    padding="35px"
  >
    <Flex column flex="50%" spacing={10}>
      <img src={icons.gclogoHorizBluegrey} width="230px" alt="" />
      <S.Speech>
        After a decade of working in corporate gyms, training independently
        and owning a studio, I realized the key to a successful fitness career
        was to include online training. Frustrated with the complexity of most
        personal training software, I set out to build my own. My goal was
        to create a platform that made it easy to build powerful online training
        plans that inspired clients to improve. Today we have GymCloud: personal
        training software made by trainers, for trainers.
      </S.Speech>
      <S.Signature>
        <Flex width={130} justify="center" align="center">
          <img src={icons.kenton} alt="" />
        </Flex>
        <Flex column>
          <S.SignatureName>Kenton Boutwell MS, CSCS</S.SignatureName>
          <S.SignaturePosition>GymCloud Founder & CEO</S.SignaturePosition>
        </Flex>
      </S.Signature>
    </Flex>
    <Flex column spacing={5}>
      <Formik
        initialValues={{
          first_name: params?.first_name || '',
          last_name: params?.last_name || '',
          email: params?.email || '',
          password: '',
          password_confirmation: '',
          agreement: false,
        }}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {(formikProps) => (
          <S.Form column onSubmit={formikProps.handleSubmit}>
            <Flex column width="100%" spacing={15}>
              <Flex
                column
                width="100%"
                align="center"
                spacing={20}
              >
                <Text
                  size="18px"
                  color="#121827"
                  weight="bold"
                  family="avenir"
                >
                  Fitness Professionals
                </Text>
                <Text
                  size="18px"
                  color="#121827"
                  weight="bold"
                  family="avenir"
                >
                  Get Your Free 30 Day Trial Now
                </Text>
              </Flex>
              <Field
                name="first_name"
                label="First Name"
                component={TextField}
                type="text"
                placeholder="your first name"
              />
              <Field
                name="last_name"
                label="Last Name"
                component={TextField}
                type="text"
                placeholder="your last name"
              />
              <Field
                name="email"
                label="Email"
                component={TextField}
                type="text"
                placeholder="your@email.com"
              />
              <Field
                name="password"
                label="Password"
                component={PasswordField}
                placeholder="Set a password"
              />
              <Field
                name="password_confirmation"
                label="Confirm Password"
                component={PasswordField}
                placeholder="Set a password"
              />
              <Field
                name="agreement"
                justify="center"
                className="agreement"
                label={(
                  <span>
                    {'I Accept the '}
                    <a
                      href="https://www.gymcloud.com/legal/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      GymCloud Terms and Privacy Policy
                    </a>
                  </span>
                )}
                component={CheckboxField}
              />
              <Flex
                width="100%"
                justify="space-between"
                align="center"
              >
                <Button
                  fit
                  type="submit"
                  spacing="big"
                  borderRadius="5px"
                  isDisabled={(!formikProps.isValid || formikProps.isSubmitting)}
                  isLoading={formikProps.isSubmitting}
                  appearance="primaryBright"
                >
                  Start My Free Trial
                </Button>
              </Flex>
              <Flex width="100%" justify="center">
                <div>
                  Already have an account?
                  {' '}
                  <Link to="/login">Sign in</Link>
                </div>
              </Flex>

              {process.env.TARGET_ENV !== 'production' && (
                <Flex width="100%" justify="center">
                  <SetNamespace />
                </Flex>
              )}
            </Flex>
          </S.Form>
        )}
      </Formik>
      <S.TextCenter>
        Are you a client? Don&apos;t worry, your fitness professional
        will send you an email invitation.
      </S.TextCenter>
    </Flex>
  </Container>
);

export default ProForm;
